import React, { Component } from 'react';
import { DashboardCard } from './DashboardCard';
import { ClipboardCheckIcon, CheckCircleIcon, XCircleIcon, AlertTriangleIcon, ArrowUpDownIcon, FilterIcon, DropletIcon, ZapIcon, CircleIcon, ConstructionIcon, ChevronLeftIcon, ChevronRightIcon, SettingsIcon, InfoIcon } from 'lucide-react';
export function ClaimsOverview() {
  // Mock data
  const warrantyData = {
    total: 125,
    approved: 100,
    rejected: 25,
    warranty: 80,
    technicalIssue: 20,
    missingPart: 5
  };
  const regions = [{
    name: 'R1 Aisco MENA',
    value: 20,
    max: 50,
    percentage: 40
  }, {
    name: 'R2 Aisco Africa',
    value: 30,
    max: 50,
    percentage: 60
  }, {
    name: 'R3 Aisco EUROPE',
    value: 50,
    max: 50,
    percentage: 100
  }, {
    name: 'R4 Aisco AMERICA',
    value: 25,
    max: 50,
    percentage: 50
  }];
  const intelligentBoardIssues = [{
    id: 1,
    title: 'Leaks and Seal Damage',
    icon: <DropletIcon size={18} data-id="element-860" />,
    color: 'blue',
    description: ['Issues with O-rings, gaskets, seals in critical components.', 'Problems with leaking, causing noise and wear.'],
    affectedParts: ['12-90301', '12-80201', '12-93311'],
    chartData: {
      jan: 10,
      feb: 15,
      mar: 12,
      apr: 25,
      may: 35,
      jun: 40,
      jul: 30
    }
  }, {
    id: 2,
    title: 'Defective Electrical Components',
    icon: <ZapIcon size={18} data-id="element-861" />,
    color: 'amber',
    description: ['Issues with relays, contactors, pressure sensors, and SCADA system control problems.', 'Failures in remote control systems and connectivity within the irrigation system.'],
    affectedParts: ['12-92311', '12-85001', '12-80021'],
    chartData: {
      jan: 5,
      feb: 8,
      mar: 10,
      apr: 12,
      may: 15,
      jun: 18,
      jul: 20
    }
  }, {
    id: 3,
    title: 'Wheel and Tire Issues',
    icon: <CircleIcon size={18} data-id="element-862" />,
    color: 'red',
    description: ['Damaged tires are frequently installed from the production line (not from transit).', 'Cracks and punctures wear on tire structure.'],
    affectedParts: ['12-85001', '12-80011', '12-93111'],
    chartData: {
      jan: 8,
      feb: 12,
      mar: 10,
      apr: 18,
      may: 25,
      jun: 30,
      jul: 20
    }
  }];
  return <div className="space-y-6" data-id="element-863">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-864">
        <DashboardCard icon={<ClipboardCheckIcon size={20} className="text-blue-400" data-id="element-866" />} title="Warranty Summary" data-id="element-865">
          <div className="flex flex-col items-center" data-id="element-867">
            <div className="text-6xl font-bold text-white mb-6" data-id="element-868">
              {warrantyData.total}
            </div>
            <div className="grid grid-cols-2 gap-6 w-full" data-id="element-869">
              <div className="text-center" data-id="element-870">
                <div className="text-green-400 font-medium mb-1" data-id="element-871">Approved</div>
                <div className="text-2xl font-bold text-white" data-id="element-872">
                  {warrantyData.approved}
                </div>
                <div className="mt-2 text-xs text-blue-300" data-id="element-873">
                  {Math.round(warrantyData.approved / warrantyData.total * 100)}
                  % of total
                </div>
              </div>
              <div className="text-center" data-id="element-874">
                <div className="text-red-400 font-medium mb-1" data-id="element-875">Rejected</div>
                <div className="text-2xl font-bold text-white" data-id="element-876">
                  {warrantyData.rejected}
                </div>
                <div className="mt-2 text-xs text-blue-300" data-id="element-877">
                  {Math.round(warrantyData.rejected / warrantyData.total * 100)}
                  % of total
                </div>
              </div>
            </div>
            <div className="w-full mt-6" data-id="element-878">
              <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-879">
                <div className="bg-green-500 h-2.5 rounded-full" style={{
                width: `${warrantyData.approved / warrantyData.total * 100}%`
              }} data-id="element-880"></div>
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<AlertTriangleIcon size={20} className="text-blue-400" data-id="element-882" />} title="Warranty Types" className="md:col-span-2" data-id="element-881">
          <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-883">
            <WarrantyTypeCard label="Warranty" value={warrantyData.warranty} percentage={warrantyData.warranty / warrantyData.total * 100} color="blue" data-id="element-884" />
            <WarrantyTypeCard label="Technical Issue" value={warrantyData.technicalIssue} percentage={warrantyData.technicalIssue / warrantyData.total * 100} color="amber" data-id="element-885" />
            <WarrantyTypeCard label="Missing Part" value={warrantyData.missingPart} percentage={warrantyData.missingPart / warrantyData.total * 100} color="emerald" data-id="element-886" />
          </div>
          <div className="space-y-4" data-id="element-887">
            {regions.map(region => <div key={region.name} className="space-y-2" data-id="element-888">
                <div className="flex justify-between" data-id="element-889">
                  <span className="text-sm text-blue-300" data-id="element-890">{region.name}</span>
                  <span className="text-sm font-medium text-white" data-id="element-891">
                    {region.value} claims
                  </span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2 overflow-hidden" data-id="element-892">
                  <div className="bg-blue-500 h-2 rounded-full" style={{
                width: `${region.percentage}%`
              }} data-id="element-893"></div>
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <div className="mb-4" data-id="element-894">
        <div className="flex items-center justify-between mb-4" data-id="element-895">
          <div className="flex items-center" data-id="element-896">
            <div className="flex items-center space-x-1 bg-slate-800 px-3 py-1 rounded-lg" data-id="element-897">
              <span className="text-blue-300 font-bold" data-id="element-898">I</span>
              <span className="text-blue-300 font-bold" data-id="element-899">B</span>
              <span className="text-blue-300 font-bold" data-id="element-900">I</span>
              <span className="text-xs text-blue-400" data-id="element-901">v1.0</span>
            </div>
            <h2 className="text-xl font-bold text-white ml-3" data-id="element-902">
              Intelligent <span className="text-blue-400" data-id="element-903">B</span>oard{' '}
              <span className="text-blue-400" data-id="element-904">I</span>ssue
            </h2>
          </div>
          <div className="flex items-center space-x-2" data-id="element-905">
            <button className="text-blue-300 hover:text-white transition-colors" data-id="element-906">
              <SettingsIcon size={18} data-id="element-907" />
            </button>
            <button className="text-blue-300 hover:text-white transition-colors" data-id="element-908">
              <InfoIcon size={18} data-id="element-909" />
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-910">
          {intelligentBoardIssues.map(issue => <IssueCard key={issue.id} issue={issue} data-id="element-911" />)}
        </div>
      </div>
    </div>;
}
function WarrantyTypeCard({
  label,
  value,
  percentage,
  color
}) {
  const colors = {
    blue: 'bg-blue-500/20 text-blue-300',
    amber: 'bg-amber-500/20 text-amber-300',
    emerald: 'bg-emerald-500/20 text-emerald-300'
  };
  return <div className={`rounded-lg p-4 ${colors[color]}`} data-id="element-912">
      <div className="text-lg font-medium mb-2" data-id="element-913">{label}</div>
      <div className="text-3xl font-bold text-white mb-2" data-id="element-914">{value}</div>
      <div className="w-full bg-slate-700/50 rounded-full h-1.5 overflow-hidden" data-id="element-915">
        <div className={`bg-${color}-500 h-1.5 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-916"></div>
      </div>
      <div className="mt-1 text-xs" data-id="element-917">{Math.round(percentage)}% of total</div>
    </div>;
}
function IssueCard({
  issue
}) {
  const colors = {
    blue: 'bg-blue-500/20 text-blue-300 border-blue-500/30',
    amber: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
    red: 'bg-red-500/20 text-red-300 border-red-500/30'
  };
  return <div className={`border rounded-xl p-5 ${colors[issue.color]}`} data-id="element-918">
      <div className="flex justify-between items-start mb-4" data-id="element-919">
        <div className="flex items-center" data-id="element-920">
          <div className="p-2 rounded-lg bg-slate-800/50 mr-2" data-id="element-921">
            {issue.icon}
          </div>
          <h3 className="text-lg font-bold text-white" data-id="element-922">{issue.title}</h3>
        </div>
        <div className="flex space-x-1" data-id="element-923">
          <button className="p-1 rounded-lg bg-slate-800/50 hover:bg-slate-700/50 transition-colors" data-id="element-924">
            <ChevronLeftIcon size={16} data-id="element-925" />
          </button>
          <button className="p-1 rounded-lg bg-slate-800/50 hover:bg-slate-700/50 transition-colors" data-id="element-926">
            <ChevronRightIcon size={16} data-id="element-927" />
          </button>
        </div>
      </div>
      <div className="h-24 mb-3 relative" data-id="element-928">
        <div className="absolute inset-0 flex items-end justify-between px-2" data-id="element-929">
          {Object.entries(issue.chartData).map(([month, value]) => <div key={month} className="flex flex-col items-center" data-id="element-930">
              <div className={`w-6 bg-${issue.color === 'blue' ? 'blue' : issue.color === 'amber' ? 'amber' : 'red'}-500 rounded-t-sm`} style={{
            height: `${value * 1.5}px`
          }} data-id="element-931"></div>
              <div className="text-xs mt-1" data-id="element-932">
                {month.substring(0, 3).toUpperCase()}
              </div>
            </div>)}
        </div>
        <div className="absolute top-0 left-0 right-0 flex justify-center" data-id="element-933">
          <div className="px-2 py-0.5 bg-red-500/20 text-red-300 text-xs rounded-full" data-id="element-934">
            Peak
          </div>
        </div>
      </div>
      <div className="space-y-2 mb-4" data-id="element-935">
        {issue.description.map((desc, idx) => <p key={idx} className="text-sm" data-id="element-936">
            {desc}
          </p>)}
      </div>
      <div data-id="element-937">
        <div className="text-xs mb-1" data-id="element-938">Affected parts:</div>
        <div className="flex flex-wrap gap-2" data-id="element-939">
          {issue.affectedParts.map((part, idx) => <div key={idx} className="px-2 py-1 bg-slate-800/50 rounded-md text-xs" data-id="element-940">
              {part}
            </div>)}
        </div>
      </div>
    </div>;
}